export const applicationShellPageLayoutClassName = "py-10 sm:px-6 lg:px-8";

export const applicationShellPageContentClassName = "mx-auto px-4";
